export class BatchAddModel {
    batchNumberProperty: string | null = null;
    batchNumber: string | null = null;
    quantity: number | null = null;
    expiryDate: string | null = null;
    manufacturingDate: string | null = null;
    addmisionDate: any = new Date();
    internalSerialNumber: string | null = null;
    itemCode: string | null = null;
    manufacturerSerialNumber: string | null = null;
    numOfBatch: any;
    mfrStringName: string | null | undefined = undefined;
    stringType: string | null | undefined = undefined;
    operationType: string | null | undefined = undefined;
    stringName: string | null | undefined = undefined;
    mfrStringType: string | null | undefined = undefined;
    mfrNumberType: string | null | undefined = undefined;
    mfrNumberValue: string | null | undefined = undefined;
    mfrOperNumberType: string | null | undefined = undefined;
    mfrOperStringType: string | null | undefined = undefined;
    srNStringName: string | null | undefined = undefined;
    srStringType: string | null | undefined = undefined;
    srOperStringType: string | null | undefined = undefined;
    srNumberType: string | null | undefined = undefined;
    srNumberValue: string | null | undefined = undefined;
    srNumberStrName: string | null | undefined = undefined;
    srOperType: string | null | undefined = undefined;
    srOperNumberType: string | null | undefined = undefined;
    lotStringType: string | null | undefined = undefined;
    lotOperStringType: string | null | undefined = undefined;
    lotStringName: string | null | undefined = undefined;
    lotOperType: string | null | undefined = undefined;
    lotNumberType: string | null | undefined = undefined;
    lotNumberValue: string | null | undefined = undefined;
    lotOperNumberType: string | null | undefined = undefined;
    binLocationValue:string| null | undefined = undefined;
}